module.exports = __webpack_public_path__ + "img/Bloque_social.645c2cb.svg";